import { IWizardStepTwoUses } from '../types';

export const calculateTotalDeveloperFee = (values: Pick<IWizardStepTwoUses,
    | 'developerFeePercent'
    | 'acquisitionCosts'
    | 'totalHardCosts'
    | 'totalSoftCosts'
    | 'interestReserve'>): number => {
    const totalUsesExcludingDevFee = (values.acquisitionCosts ?? 0) + values.totalHardCosts + values.totalSoftCosts + values.interestReserve;
    const devFeePercent = values.developerFeePercent === 1 ? 0.9999999999 : values.developerFeePercent ?? 0;
    const developerFeeTotal = (devFeePercent * totalUsesExcludingDevFee) / (1 - devFeePercent);

    return developerFeeTotal;
};

export const calculateDeveloperFeePercent = (values: Pick<IWizardStepTwoUses,
    | 'acquisitionCosts'
    | 'totalHardCosts'
    | 'totalSoftCosts'
    | 'interestReserve'
    | 'developerFee'>): number => {
    const totalUses = (values.acquisitionCosts ?? 0) + values.totalHardCosts + values.totalSoftCosts + values.interestReserve + values.developerFee;
    const developerFeePercent = values.developerFee / totalUses;
    return developerFeePercent;
};
